<template>
  <div class="share-panel-container">
    <div class="share-button facebook">FB</div>
    <div class="share-button line">Line</div>
  </div>
</template>

<script>
export default {
  name: 'SharePanel',
}
</script>

<style lang="scss" scoped>
  .share-panel-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .share-button {
      position: relative;
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #000000;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>

